import { createTheme } from "@mui/material";

const index = createTheme({
  palette: {
    primary: {
      main: "#6B47F5",
    },
    secondary: {
      main: "#6B47F5",
    },
    greenBsf: {
      main: "#00718A",
    },
    cartrust: {
      main: "#54A8DB",
    },
    syarah: {
      main: "#0D0D75",
    },
    greenSnb: {
      main: "#0C7560",
    },
    purpleStc: {
      main: "#4f008c",
    },
    petromin: {
      main: "#DC334E",
    },
  },
  typography: {
    button: {
      color: "white",
    },
    body3: {
      fontSize: "14px",
      fontWeight: "800",
    },
    sectionHeading: {
      color: "#1A1C1F",
      fontWeight: "800",
      fontSize: "20px",
    },
    sectionHeadingSub: {
      color: "#455560",
      fontWeight: "500",
      fontSize: "16px",
    },
    buttonLarge: {
      fontSize: "20px",
      fontWeight: "800",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default index;
